import type { IconSvgObject } from './types';

const Txt02Icon: IconSvgObject = [
  ["path", { d: "M19 22H5C3.89543 22 3 21.1046 3 20L3 4C3 2.89543 3.89543 2 5 2H12L19 9V11M18.5 9H13.998C12.8935 9 11.998 8.10457 11.998 7V2.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18 14H19.5M19.5 14H21M19.5 14V19M7 14H8.5M8.5 14H10M8.5 14V19M12.5 14L14 16.5M14 16.5L15.5 19M14 16.5L15.5 14M14 16.5L12.5 19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Txt02Icon;
